import Fetch, { serializeQueryString, V2 } from 'Util/fetcher';

const ON_REQUEST_RDN_HISTORY = 'ON_REQUEST_RDN_HISTORY';
const ON_REQUEST_RDN_HISTORY_FAILURE = 'ON_REQUEST_RDN_HISTORY_FAILURE';
const ON_REQUEST_RDN_HISTORY_SUCCESS = 'ON_REQUEST_RDN_HISTORY_SUCCESS';

function onRequestRDNHistory(resetData) {
  return {
    type: ON_REQUEST_RDN_HISTORY,
    meta: { resetData },
  };
}

function onRequestRDNHistorySuccess(payload) {
  return {
    type: ON_REQUEST_RDN_HISTORY_SUCCESS,
    payload,
  };
}

function onRequestRDNHistoryFailure(payload) {
  return {
    type: ON_REQUEST_RDN_HISTORY_FAILURE,
    payload,
  };
}

export const onDoRequestRDNHistory =
  (params, resetData = false) =>
  (dispatch) => {
    dispatch(onRequestRDNHistory(resetData));
    Fetch.get(`${V2}payment/rdn/history/${serializeQueryString(params)}`)
      .then((resp) => {
        if (resp.ok) {
          dispatch(onRequestRDNHistorySuccess(resp.json));
        } else {
          dispatch(onRequestRDNHistoryFailure(resp.json));
        }
      })
      .catch((error) => {
        dispatch(onRequestRDNHistoryFailure(error.message));
      });
  };

const ON_REQUEST_RDN_TRANSFER = 'ON_REQUEST_RDN_TRANSFER';
const ON_REQUEST_RDN_TRANSFER_FAILURE = 'ON_REQUEST_RDN_TRANSFER_FAILURE';
const ON_REQUEST_RDN_TRANSFER_SUCCESS = 'ON_REQUEST_RDN_TRANSFER_SUCCESS';

function onRequestRDNTransfer() {
  return {
    type: ON_REQUEST_RDN_TRANSFER,
  };
}

function onRequestRDNTransferSuccess(payload) {
  return {
    type: ON_REQUEST_RDN_TRANSFER_SUCCESS,
    payload,
  };
}

function onRequestRDNTransferFailure(payload) {
  return {
    type: ON_REQUEST_RDN_TRANSFER_FAILURE,
    payload,
  };
}

export const onDoRequestRDNTransfer = (payload) => (dispatch) => {
  dispatch(onRequestRDNTransfer());
  Fetch.post(`${V2}stock/rdn/transfer-rdn/`, payload, false, false)
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestRDNTransferSuccess(resp.json));
      } else {
        dispatch(onRequestRDNTransferFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestRDNTransferFailure(error.message));
    });
};

const INITIAL_STATE = {
  historyLoading: false,
  historyData: null,
  historyError: null,

  transferLoading: false,
  transferError: null,
  transferSuccess: null,
};

const profile = (state = INITIAL_STATE, action = {}) => {
  const newState = { ...state };
  switch (action.type) {
    case ON_REQUEST_RDN_HISTORY:
      if (action.meta.resetData) {
        return {
          ...state,
          historyLoading: true,
          historyData: null,
          historyError: null,
        };
      }
      return { ...state, historyLoading: true, historyError: null };
    case ON_REQUEST_RDN_HISTORY_SUCCESS:
      if (state.historyData) {
        const oldDetails = [...state.historyData.result.detail];
        newState.historyData = {
          ...action.payload,
          result: {
            ...action.payload.result,
            detail: [...oldDetails, ...action.payload.result.detail],
          },
        };
      } else {
        newState.historyData = action.payload;
      }
      return {
        ...newState,
        historyLoading: false,
        historyError: null,
      };
    case ON_REQUEST_RDN_HISTORY_FAILURE:
      return {
        ...state,
        historyLoading: false,
        historyError: action.payload,
      };
    case ON_REQUEST_RDN_TRANSFER:
      return {
        ...state,
        transferLoading: true,
        transferError: null,
      };
    case ON_REQUEST_RDN_TRANSFER_SUCCESS:
      return {
        ...state,
        transferLoading: false,
        transferError: null,
        transferSuccess: action.payload,
      };
    case ON_REQUEST_RDN_TRANSFER_FAILURE:
      return {
        ...state,
        transferLoading: false,
        transferError: action.payload,
      };
    default:
      return state;
  }
};

export default profile;
